import React from "react";
import resumeFile from "../documents/resume.pdf";

const Resume = ({ classicHeader, darkTheme }) => {
  const educationDetails = [
    {
      yearRange: "2014 - 2020",
      title: "Bachelor Degree in Business Administration",
      place: "Damascus University",
      desc: "Graduated with merit",
    },
    {
      yearRange: "2014 - 2016",
      title: "Diploma in Computer Information Science",
      place: "UNRWA Damascus Training Center (DTC)",
      desc: "Graduated with distinction",
    },
  ];

  const experienceDetails = [
    {
      yearRange: "Mar 2021 - Present",
      title: "Mid Level .Net Developer",
      place: "Lexham Insurance",
      desc: (
        <ul>
          <li>
            Researching, designing, implementing, and managing software programs
          </li>
          <li>Testing and evaluating new programs</li>
          <li>
            Identifying areas for modification in existing programs and
            subsequently developing these modifications
          </li>
          <li>Writing and implementing efficient code</li>
          <li>Determining operational practicality</li>
          <li>Developing quality assurance procedures</li>
          <li>Deploying software tools, processes, and metrics</li>
          <li>Maintaining and upgrading existing systems</li>
        </ul>
      ),
    },
    {
      yearRange: "Jul 2017 - Oct 2020",
      title: "Software Developer",
      place: "Jafra Foundation",
      desc: (
        <ul>
          <li>
            Researching, designing, implementing, and managing software programs
          </li>
          <li>Testing and evaluating new programs</li>
          <li>
            Identifying areas for modification in existing programs and
            subsequently developing these modifications
          </li>
          <li>Writing and implementing efficient code</li>
          <li>Determining operational practicality</li>
          <li>Developing quality assurance procedures</li>
          <li>Deploying software tools, processes, and metrics</li>
          <li>Maintaining and upgrading existing systems</li>
        </ul>
      ),
    },
    {
      yearRange: "Aug 2018 - Oct 2020",
      title: "IT Officer",
      place: "Jafra Foundation",
      desc: (
        <ul>
          <li>
            Follow-up the status of devices in the foundation with the rest of
            the IT team
          </li>
          <li>
            Choose the quality and specifications of the devices that ensure the
            proper functioning
          </li>
          <li>
            Corporate with purchase department in technical evaluation and
            choose the best offer
          </li>
          <li>
            Prepare the purchase requisition of the devices and send them to the
            purchasing department to buy
          </li>
          <li>Replace devices that need to be replaced</li>
        </ul>
      ),
    },
    {
      yearRange: "Jul 2017 - Jul 2018",
      title: "IT Help Desk",
      place: "Jafra Foundation",
      desc: (
        <ul>
          <li>
            Install and set up the operating system on computers as well as
            platforms, services and assistance according to the installation and
            setup guide in the IT department.
          </li>
          <li>Help with choosing the right device to buy for working </li>
          <li>
            Test operating systems, platforms, assistance, maintain and ensure
            readiness and connectivity to network services
          </li>
          <li>
            Provide maintenance services and technical support directly or
            online to the institution's staff by analyzing the problem and
            trying to solve it
          </li>
          <li>
            Refer to Systems Manager or Section Manager for issues that I cannot
            resolve
          </li>
          <li>
            Record problems and add them to the technical support guide as well
            as provide user guides for basic network services to make it easier
            for users to access these services
          </li>
          <li>
            Follow up the problems that appear to users and ensure that the
            solution has been found and ensure the availability of appropriate
            technical support allows the user to continue to do his work
          </li>
          <li>
            Prepare periodic reports and update the status of devices to keep
            his administration informed of the technical situation of computers,
            systems, and services.
          </li>
          <li>
            Conduct quarterly inventories of all electronic devices (printers,
            computers, communication devices), etc.
          </li>
          <li>
            Maintaining the confidentiality of electronic information for
            employees and not circulating it
          </li>
        </ul>
      ),
    },
  ];

  const skills = [
    {
      name: ".Net",
    },
    {
      name: "C#",
    },
    {
      name: "ASP.NET Core/MVC",
    },
    {
      name: "PHP, Laravel, OOP",
    },
    {
      name: "Web Design: HTML5, CSS3, SCSS/SASS",
    },
    {
      name: "JavaScript",
    },
    {
      name: "JQuery",
    },
    {
      name: "React",
    },
    {
      name: "NodeJS and ExpressJs",
    },
    {
      name: "RESTful Web Services",
    },
    {
      name: "Mobile Apps: React Native",
    },
    {
      name: "SQL/MYSQL",
    },

    {
      name: "GIT",
    },
    {
      name: "Azure DevOps",
    },
    {
      name: "Azure Portal",
    },

    // {
    //   name: "PostgresSQL",
    // },
  ];

  return (
    <section
      id="resume"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Summary
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Resume
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gx-5">
          {/* My Education */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Education
            </h2>
            {educationDetails.length > 0 &&
              educationDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
          {/* My Experience */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Experience
            </h2>
            {experienceDetails.length > 0 &&
              experienceDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
        </div>
        {/* My Skills */}
        <h2
          className={
            "text-6 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")
          }
        >
          My Skills
        </h2>
        <div className="row gx-5">
          {skills.length > 0 &&
            skills.map((skill, index) => (
              <div key={index} className="col-md-6">
                <p
                  className={
                    " fw-500 text-start mb-2 " +
                    (darkTheme ? "text-light" : "text-dark")
                  }
                >
                  {skill.name}{" "}
                  {skill.percent && (
                    <span className="float-end">{skill.percent}%</span>
                  )}
                </p>
                {skill.percent && (
                  <div
                    className={
                      "progress progress-sm mb-4 " +
                      (darkTheme ? "bg-dark" : "")
                    }
                  >
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: skill.percent + "%" }}
                      aria-valuenow={skill.percent}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    />
                  </div>
                )}
              </div>
            ))}
        </div>
        {/* <div className="text-center mt-5">
          <a
            className="btn btn-outline-secondary rounded-pill shadow-none"
            href={resumeFile}
            download
          >
            Download CV
            <span className="ms-1">
              <i className="fas fa-download" />
            </span>
          </a>
        </div> */}
      </div>
    </section>
  );
};

export default Resume;
